import { render } from "./RoomFormSidebar.vue?vue&type=template&id=206db5a8"
import script from "./RoomFormSidebar.vue?vue&type=script&lang=js"
export * from "./RoomFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__